function renderMemberStatus() {
  const member = Shopify.functions.getMemberFromStorage();
  Shopify.functions.showMemberSections(member);

  if (!member) return;

  document.querySelectorAll('.loyalty-member-points').forEach((element) => {
    element.textContent = member.points ?? '–';
  });
}

renderMemberStatus();
document.addEventListener('member-updated', renderMemberStatus);
